/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="ck-card shipping-address-form">
    <div class="ck-card-title">{{ $t('ShippingAddress') }}</div>
    <shipping-address
      ref="shippingAddress"
      :address="shippingAddressFields"
      name="shipping-address-form"
      v-validate="'required'"
      v-model="formValue"
      :use-address-form="true"
      :show-submit-button="false"
      @submit="submitShippingAddressForm($event)"
      @changeCountry="$emit('changeCountry', $event)"/>
  </div>
</template>

<script>
import ShippingAddress from 'theme/components/Form/GenericAddressForm'

export default {
  name: 'ShippingAddressForm',
  props: {
    value: {
      type: Boolean,
      default: () => false
    },
    name: {
      type: String,
      default: () => 'shipping-address-form'
    },
    shippingAddressFields: {
      type: Object,
      required: true
    }
  },
  $_veeValidate: {
    validator: 'new',
    name () {
      return this.name
    }
  },
  data () {
    return {
      showAddressList: false,
      formValue: false
    }
  },
  computed: {
    shippingAddressFieldsStreet () {
      return this.shippingAddressFields.street.join(' ')
    }
  },
  methods: {
    submitShippingAddressForm (newAddress) {
      this.$store.commit('checkout/setShippingAddress', newAddress)
    },
    selectFromList () {
      this.showAddressList = true
    },
    addressSelected (address) {
      this.shippingAddressFields.region.region_code = address.region ? address.region.region_code : ''
      this.shippingAddressFields.region.region = address.region ? address.region.region : ''
      this.shippingAddressFields.region.region_id = address.region ? address.region.region_id : ''
      this.shippingAddressFields.country_id = address.country_id || ''
      this.shippingAddressFields.street = address.street ? [...address.street] : []
      this.shippingAddressFields.telephone = address.telephone || ''
      this.shippingAddressFields.postcode = address.postcode || ''
      this.shippingAddressFields.city = address.city || ''
      this.shippingAddressFields.firstname = address.firstname || ''
      this.shippingAddressFields.lastname = address.lastname || ''
      this.$refs.shippingAddress.changeAddress()
    },
    handleSubmit () {
      return this.$refs.shippingAddress.handleSubmit()
    }
  },
  components: {
    ShippingAddress
  }
}
</script>
<style lang="scss" scoped>
.description-list{
  list-style: none;
  text-align: left;
}
</style>
